module.exports = __webpack_public_path__ + "media/images/lp_hirakawa_interview-75aae17ed86b7256d4f23a023e46f858.webp";